module.exports = __webpack_public_path__ + "img/stock-photo-car-service-transportation-concept-tow-truck-transpo.5415a696.png";